import { render, staticRenderFns } from "./FormPageUnit.vue?vue&type=template&id=e2b0e0da&"
import script from "./FormPageUnit.vue?vue&type=script&lang=js&"
export * from "./FormPageUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentSDD/build/corpmessengerwebapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e2b0e0da')) {
      api.createRecord('e2b0e0da', component.options)
    } else {
      api.reload('e2b0e0da', component.options)
    }
    module.hot.accept("./FormPageUnit.vue?vue&type=template&id=e2b0e0da&", function () {
      api.rerender('e2b0e0da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Manda/FormPageUnit.vue"
export default component.exports